import * as React from 'react';
import { BevPageTypes } from '../BevPageTypes';
import { getConvertedWH, convertToNumber } from '../helpers/generalHelpers';
import {
  getBackgroundColor,
  getBorderColor,
  isClickableUnit,
  ZIndex,
} from '../helpers/styleHelpers';

export const Unit = ({
  selectedUnitTypeId,
  singleUnit,
  zoomValue,
  selectedUnitId,
  clickHandler,
  id,
  defaultUnitId,
  isFacilityMigrated,
}: BevPageTypes.TUnitComponent) => {
  const {
    bev: {
      x: bevX = 0,
      y: bevY = 0,
      width: bevWidth = 0,
      depth: bevHeight = 0,
      angle = 0,
    },
  } = singleUnit;
  const { width, height } = getConvertedWH(
    bevWidth,
    bevHeight,
    isFacilityMigrated
  );

  return (
    <div
      onClick={() => clickHandler(singleUnit)}
      id={id.toString()}
      className={`unit
       ${getBorderColor(singleUnit, selectedUnitTypeId)}
       ${getBackgroundColor(singleUnit, selectedUnitId)}
       `}
      data-cy={`activeBorder-${id.toString()}`}
      style={{
        width,
        height,
        zIndex: ZIndex(singleUnit, defaultUnitId),
        left: convertToNumber(bevX) * zoomValue,
        top: convertToNumber(bevY) * zoomValue,
        WebkitTransform: `scale(${zoomValue}) rotate(${angle}deg)`,
        WebkitTransformOrigin: 'left top',
        pointerEvents: isClickableUnit(singleUnit, selectedUnitTypeId)
          ? 'auto'
          : 'none',
        cursor: isClickableUnit(singleUnit, selectedUnitTypeId)
          ? 'pointer'
          : 'not-allowed',
      }}
    ></div>
  );
};
